const today = new Date();
const year = today.getFullYear();
const month = today.getMonth() + 1;
const day = today.getDate();

// => '2025-04-15'
const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;

// => ['2025', '04', '15']
var datearray = formattedDate.split("-");

// => "Apr 15, 2025"
const formatDate = (dateString,) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(dateString);
  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: userTimeZone,
  };
  return date.toLocaleString('en-US', options);
};

// => "12:00 AM"
const formatTime = (dateString) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(dateString);
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: userTimeZone
  };
  return date.toLocaleString('en-US', options);
};

// => "15/4/2025"
const formatDateDDMMYYYY = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// => "4/15/2025"
const formatDateMMDDYYYY = (date) =>
  new Date(date).toLocaleString('en-US', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });

// => "15-04-2025"
const formatDateDD_MM_YYYY = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

// => "April 15, 2025"
const formattedDateLong = (date) =>
  new Date(date).toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

// => "April 15"
const formattedDateNoYear = (date) =>
  new Date(date).toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
  });

// => {
//      toString: () => "15/04/2025(12:00:00 AM)",
//      full: "15/04/2025, 12:00:00 AM",
//      date: "15/04/2025",
//      time: "12:00:00 AM"
//    }
const formatDateTime = (datetimeStr) => {
  const dateObj = new Date(datetimeStr);
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();
  const dateFormatted = `${day}/${month}/${year}`;
  const timeFormatted = dateObj.toLocaleTimeString();
  const defaultFormat = `${dateFormatted}(${timeFormatted})`;
  return {
    toString: () => defaultFormat,
    full: `${dateFormatted}, ${timeFormatted}`,
    date: dateFormatted,
    time: timeFormatted
  };
};

export {
  formatDate,
  formatTime,
  formatDateDDMMYYYY,
  formatDateMMDDYYYY,
  formatDateDD_MM_YYYY,
  formattedDate,
  datearray,
  formattedDateLong,
  formattedDateNoYear,
  formatDateTime
}